import { FaMedal, FaCalendarAlt, FaThLarge, FaRedoAlt } from "react-icons/fa";

export const puzzleDestinations = [
  { href: "/puzzles", labelKey: "nav.leagueShort", menuLabel: "Puzzle League", icon: FaMedal },
  { href: "/puzzle", labelKey: "nav.dailyShort", menuLabel: "Daily puzzles", icon: FaCalendarAlt },
  { href: "/puzzles/themes", labelKey: "nav.themesShort", menuLabel: "Puzzle themes", icon: FaThLarge },
  { href: "/puzzles/mistakes/practice", labelKey: "nav.mistakes", menuLabel: "My mistakes", icon: FaRedoAlt },
];
